import React from 'react';

function Updates() {
const updates = [
{
version: '1.2.0',
date: 'January 19, 2025',
features: [
'Added bulk delete functionality for messages.',
'Simplified prompt selection; you can now access prompts directly from the input field by typing "///".'
]
},
{
version: '1.1.0',
date: 'January 17, 2025',
features: [
'Introduced the ability to select prompts.',
'Resolved a UI bug in the manage chats section.',
'Improved modal opening speed with performance updates.',
'Fixed the JSON export issue.',
'Added TXT export functionality.'
]
},
{
version: '1.0.0',
date: 'January 14, 2025',
features: [
'The extension is now ready for release!'
]
}
];

return (
<div className="bg-gray-100 min-h-screen py-12">
<div className="max-w-4xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden">
<div className="bg-indigo-600 py-6 px-8 text-white">
<h2 className="text-3xl font-bold">Extension Updates</h2>
<p className="mt-2 text-indigo-200">Stay up-to-date with the latest improvements and features.</p>
</div>

<div className="px-8 py-6">
      {updates.map((update, index) => (
        <div key={index} className="mb-6 p-4 rounded-md border border-gray-200 hover:shadow-md transition duration-200">
          <div className="flex justify-between items-center mb-3">
            <span className="text-lg font-semibold text-gray-800">Version {update.version}</span>
            <span className="text-sm text-gray-500">{update.date}</span>
          </div>
          <ul className="list-disc pl-5 text-gray-700">
            {update.features.map((feature, i) => (
              <li key={i} className="mb-1 text-left">{feature}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>

    <div className="bg-gray-50 py-3 px-8 text-gray-500">
      <p>© 2023 My Extension. All rights reserved.</p>
    </div>
  </div>
</div>
);
}

export default Updates;